import React, { FC, useCallback } from 'react'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'
import s from './PaginationToolbarStyle.module.scss'
type Props = {
    isActive: boolean
    number: number
    onClick: (x: number) => void
}

export const Tiles: FC<Props> = ({ isActive, number, onClick }) => {
    const handleClick = useCallback(() => onClick(number), [onClick, number])

    return (
        <li
            className={cn(s['page-item'], {
                active: isActive
            })}
        >
            {isActive ? (
                <span className="page-link">{number}</span>
            ) : (
                <Button
                    className="page-link"
                    variant="link"
                    onClick={handleClick}
                    onKeyDown={handleClick}
                >
                    {number}
                </Button>
            )}
        </li>
    )
}
